import LayoutTransparencia from '~componentes/LayoutTransparencia.vue';
import Transparencia from './componentes/Transparencia.vue';
import Projetos from './componentes/compartilhado/Projetos.vue';
import DetalharProjeto from './componentes/compartilhado/DetalharProjeto.vue';
import ListaProjetos from './componentes/compartilhado/ListaProjetos.vue';
import RelatoriosProjeto from './componentes/compartilhado/RelatoriosProjeto.vue'
import DetalharCompraLicitacao from './componentes/compartilhado/DetalharCompraLicitacao.vue'
import DetalharAcompanhamentoProjeto from './componentes/compartilhado/DetalharAcompanhamentoProjeto.vue';
import Institucional from './componentes/compartilhado/institucional/Institucional.vue';
import InstitucionalDetalhes from './componentes/compartilhado/institucional/InstitucionalDetalhes.vue';
import InstitucionalVerificarPagamento from './componentes/compartilhado/institucional/InstitucionalVerificarPagamento.vue';
import RelatorioLancamentosTodosProjetos from './componentes/compartilhado/RelatorioLancamentosTodosProjetos.vue';

export default {
  path: '/transparencia',
  component: LayoutTransparencia,
  children: [
    {
      path: '',
      component: ListaProjetos,
      name: 'transparencia.projetos.inicio',
    },
    {
      path: 'lancamento-todos-projetos',
      component: RelatorioLancamentosTodosProjetos,
      name: 'transparencia.lancamento.todos.projetos',
    },
    {
      path: 'institucional',
      component: Institucional,
      name: 'transparencia.institucional',
    },
    {
      path: 'institucional/verificar-pagamento',
      component: InstitucionalVerificarPagamento,
      name: 'transparencia.institucional.verificar.pagamento',
    },
    {
      path: 'institucional/detalhar/:id',
      component: InstitucionalDetalhes,
      name: 'transparencia.institucional.detalhar',
    },
    {
      path: 'verificar-pagamento',
      component: InstitucionalVerificarPagamento,
      name: 'transparencia.verificar.pagamento',
    },
    {
      path: 'projetos',
      component: Projetos,
      children: [
        {
          path: '',
          component: ListaProjetos,
          name: 'transparencia.projetos',
        },
        {
          path: ':id',
          component: DetalharProjeto,
          name: 'transparencia.projetos.detalhar',
        },
        {
          path: ':id/lancamento/:idTipoRelatorio',
          component: RelatoriosProjeto,
          name: 'transparencia.projetos.detalhar.lancamento',
        },
        {
          path: ':id/lancamento/itens/:idPedidoCompra',
          component: DetalharCompraLicitacao,
          name: 'transparencia.projetos.detalhar-compra-licitacao',
        },
        {
          path: ':id/lancamento/acompanhamento-projeto/:idAcompanhamentoProjeto',
          component: DetalharAcompanhamentoProjeto,
          name: 'transparencia.projetos.detalhar-acompanhamento-projeto',
        },
      ],
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/transparencia/rotas.js